import React, { Component } from 'react';

class IconTicketChecked extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18">
                <path fill="#fff" d="M17.204 5.191L4.931 13.943.91 8.103a1.212 1.212 0 01.282-1.653 1.153 1.153 0 01.871-.196 1.15 1.15 0 01.751.49l2.892 4.178L16.07 3.537a.986.986 0 01.758-.18.984.984 0 01.652.432 1.018 1.018 0 01-.275 1.402z"
                ></path>
            </svg>
        );
    }
}

export default IconTicketChecked;